"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradeDropDown = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const classes_1 = require("../../../base/classes");
exports.GradeDropDown = react_1.default.memo(({ setDropValue }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const startline = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClasses)(state)?.startline);
    const [dropList, setDropList] = react_1.default.useState([]);
    const [value, setValue] = react_1.default.useState();
    (0, react_1.useEffect)(() => {
        const today = (0, moment_1.default)();
        const months = [{ id: 'all', title: '전체' }];
        let currentDate = (0, moment_1.default)(startline);
        while (currentDate.isSameOrBefore(today, 'month')) {
            const diffMonths = today.diff(currentDate, 'months');
            const title = `${currentDate.year()}년 ${currentDate.month() + 1}월 ${currentDate.isSame(today, 'month') ? '' : `(${diffMonths + 1}개월 전)`}`;
            months.push({ id: currentDate.unix(), title });
            // Move to the next month
            currentDate.add(1, 'month');
        }
        const monthOptions = months.slice(1).reverse();
        const list = [months[0], ...monthOptions];
        setDropList(list);
        setValue(list[0]);
    }, [startline]);
    (0, react_1.useEffect)(() => {
        if (value?.id !== undefined && value?.id !== null) {
            setDropValue(String(value.id));
        }
    }, [value]);
    return (react_1.default.createElement(common_1.DropDown, { className: "dropdown-small", list: dropList, value: value, setDropValue: setValue, styles: {
            titleWrap: {
                ...(isMobile ? { width: '100%' } : { minWidth: 200, maxWidth: 200 }),
            },
        } }));
});
